import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { speak, MISSION_MESSAGES } from '../utils/speak';

/**
 * Floating "back to top" button.
 * Appears once the visitor has scrolled into the lower part of the page
 * (past ~60% of the total scrollable height) and smoothly scrolls to the top.
 * On click it also speaks the CropShield mission message.
 */
const BackToTop = ({ language = 'en' }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? window.scrollY / scrollable : 0;
      setVisible(progress > 0.6);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    const msg = MISSION_MESSAGES[language] || MISSION_MESSAGES.en;
    speak(msg.text, msg.lang);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
//hello testing
  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Back to top"
      className={`
        fixed bottom-6 right-6 z-50
        h-12 w-12 flex items-center justify-center
        rounded-full bg-emerald-600 text-white shadow-lg
        hover:bg-emerald-700 hover:-translate-y-0.5
        focus:outline-none focus:ring-2 focus:ring-emerald-300
        transition-all duration-300
        ${visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}
      `}
    >
      <FaArrowUp className="w-5 h-5" />
    </button>
  );
};

export default BackToTop;
